import { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import Violation from "./Features/Violation/Violation";
import Threats from "./Features/Threats/Threats";
import { AuthContext } from "../../context/AuthContext";
import useWindowSize from "../../components/WindowSize";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { DateRangePicker } from 'rsuite';
import { startOfDay, endOfDay, addDays, addMonths, subDays, startOfMonth, endOfMonth } from 'date-fns';
import Loader from "../../components/Loader";

export default function Securonix() {
    const { apiUrl } = useContext(AuthContext);
    const [linkPath, setLinkPath] = useState('violations');
    const today = endOfDay(new Date(), 23);
    const week = startOfDay(subDays(today, 7));
    const { afterToday, combine } = DateRangePicker;
    const [date, setDate] = useState([week, today]);
    const [minDate] = useState(null);
    const windowSize = useWindowSize();
    const placement = windowSize.width < 945 ? 'bottomStart' : 'bottomEnd';
    const { t } = useTranslation();

    const ranges = [
        {
            label: 'Aujourd\'hui',
            value: [startOfDay(new Date()), endOfDay(new Date())],
            placement: 'left'
        },
        {
            label: 'Hier',
            value: [startOfDay(addDays(new Date(), -1)), endOfDay(addDays(new Date(), -1))],
            placement: 'left'
        },
        {
            label: 'Les 7 derniers jours',
            value: [startOfDay(subDays(new Date(), 6)), endOfDay(new Date())],
            placement: 'left'
        },
        {
            label: 'Les 30 derniers jours',
            value: [startOfDay(subDays(new Date(), 29)), endOfDay(new Date())],
            placement: 'left'
        },
        {
            label: 'Ce mois-ci',
            value: [startOfMonth(new Date()), endOfDay(new Date())],
            placement: 'left'
        },
        {
            label: 'Le mois dernier',
            value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
            placement: 'left'
        }
    ];

    const handleNavigation = (path) => {
        setLinkPath(path);
    };

    const getThreats = async () => {
        const res = await axios(`${apiUrl}securonix/threats/${new Date(date[0]).getTime()}/${new Date(date[1]).getTime()}`, {
            method: "get",
            withCredentials: true
        });
        return res.data;
    };

    const threats = useQuery({
        queryKey: ["threats", date],
        queryFn: getThreats,
    });

    if (!threats.isLoading && !threats.data) {
        return (
            <div className="ecp-container">
                <div className="ecp-container-content-error">
                    <div className="error-container">
                        <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                        <div className="error-container-text">
                            <h1 className="page-title">
                                {t("Service actuellement indisponible")}
                            </h1>
                            <p className="page-link_home">
                                <Link to="/"> {t("Revenir à l'accueil")}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="ecp-container">
            <div className="ecp-container-content">
                {!threats.isLoading ? (
                    <article className="sentinelone">
                        <div className="ecp-container-content-header">
                            <div className="ecp-container-content-header-title">
                                <div className="page-title page-logo">
                                    <img src="./assets/securonix.png" alt="Logo de SentinelOne" />
                                    <h1 className="page-title">Securonix</h1>
                                </div>
                            </div>
                            <section className="choice-calendar-or-pdf">
                                <DateRangePicker
                                    ranges={ranges}
                                    cleanable={false}
                                    character=" / "
                                    value={date}
                                    onChange={setDate}
                                    format="MM-dd-yyyy HH:mm"
                                    defaultValue={[week, today]}
                                    shouldDisableDate={combine(afterToday(), (date) => minDate && date < startOfDay(new Date(minDate)))}
                                    locale={{
                                        sunday: t('Su'),
                                        monday: t('Mo'),
                                        tuesday: t('Tu'),
                                        wednesday: t('We'),
                                        thursday: t('Th'),
                                        friday: t('Fr'),
                                        saturday: t('Sa'),
                                        hours: t('Hours'),
                                    }}
                                    placement={placement}
                                />
                            </section>
                        </div>
                        <div className="menu-statistics-webex mt-1">
                            <div onClick={() => handleNavigation('violations')} className={linkPath === 'violations' ? 'active' : ''}>{t("Violations")}</div>
                            <div onClick={() => handleNavigation('threats')} className={linkPath === 'threats' ? 'active' : ''}>{t("Threats")}</div>
                        </div>
                        {linkPath === 'violations' ? (
                            <div>
                                <Violation date={date} />
                            </div>
                        ) : (
                            <div>
                                <Threats date={date} threats={threats} />
                            </div>
                        )}
                    </article>

                ) : (
                    <Loader />
                )}
            </div>
        </div>
    );
};
